import CreationThinkSeed from './container';

export default CreationThinkSeed;



// WEBPACK FOOTER //
// ./src/components/CreationThinkSeed/index.js